<template>
  <v-container class="resetPassword">
    <v-alert border="top" outlined type="error" v-if="tokenRetrievalError"
      >This password reset token is invalid. Please contact your administrator
      or <router-link to="/forgot">click here</router-link> and enter your email
      to receive a new password reset invitation. Please wait while we redirect
      you to the login page.</v-alert
    >
    <div class="formcontainer" v-else>
      <v-alert
        border="top"
        outlined
        type="success"
        v-show="passwordResetSuccess"
      >
        Your password has been successfuly reset. Please wait while we redirect
        you to the login page.
      </v-alert>
      <v-alert border="top" outlined type="error" v-show="passwordResetError">
        We encountered an error while trying to reset your password. You can try
        again, or <router-link to="/forgot">click here</router-link> and enter
        your email to receive a new password reset invitation.
      </v-alert>
      <h2>
        Hello {{ userID }}! Please enter and confirm your new password below to
        continue.
      </h2>
      <v-form
        ref="createPasswordForm"
        @submit.prevent="confirmPasswordClick"
        v-model="valid"
      >
        <v-text-field
          type="password"
          outlined
          placeholder="Password"
          autocomplete="off"
          v-model="password"
          :rules="createPasswordRules"
          :counter="6"
          required
        />
        <v-text-field
          type="password"
          outlined
          placeholder="Confirm Password"
          autocomplete="off"
          v-model="confirmPassword"
          :rules="confirmPasswordRules"
          :counter="6"
          v-on:keyup.enter="confirmPasswordClick"
          required
        />
        <v-btn
          :disabled="!valid"
          :loading="btnLoading"
          @click="confirmPasswordClick"
          outlined
          >Confirm</v-btn
        >
      </v-form>
    </div>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "ResetPassword",
  data() {
    return {
      valid: true,
      btnLoading: false,
      password: "",
      confirmPassword: "",
    };
  },
  methods: {
    confirmPasswordClick() {
      this.$refs.createPasswordForm.validate();
      if (this.valid) {
        this.btnLoading = true;
        this.$store
          .dispatch("forgot/putResetPassword", {
            password: this.password,
          })
          .then(() => {
            if (this.passwordResetSuccess) {
              setTimeout(() => {
                this.$store.dispatch("forgot/reset");
                this.resetForm();
                this.$router.push("/login");
              }, 3000);
            } else {
              this.resetForm();
            }
          });
      }
    },
    resetForm() {
      this.btnLoading = false;
      this.$refs.createPasswordForm.resetValidation();
      this.password = "";
      this.confirmPassword = "";
    },
  },
  computed: {
    createPasswordRules() {
      const rules = [];
      const length = (v) =>
        v.length >= 6 || "Password does not meet minimum length requirements.";
      rules.push(length);

      //ascii only characters
      const isASCII = (v) =>
        /^[\x00-\x7F]+$/.test(v) || "Password contains invalid characters.";
      rules.push(isASCII);
      return rules;
    },
    confirmPasswordRules() {
      const rules = [];
      const matchRule = () =>
        this.confirmPassword === this.password || "Password must match";
      rules.push(matchRule);
      const required = (v) => !!v || "Confirm Password is required!";
      rules.push(required);
      return rules;
    },
    userID() {
      return this.$store.getters["forgot/getResetUserID"];
    },
    tokenRetrievalError() {
      return this.$store.getters["forgot/getTokenRetrievalError"];
    },
    passwordResetError() {
      return this.$store.getters["forgot/getResetPasswordError"];
    },
    passwordResetSuccess() {
      return this.$store.getters["forgot/getResetPasswordSuccess"];
    },
  },
  created() {
    if (this.$route.query.Token) {
      //GET Forgot
      this.$store
        .dispatch("forgot/getResetPasswordUserID", this.$route.query)
        .then(() => {
          if (this.tokenRetrievalError) {
            setTimeout(() => {
              this.$router.push("/login");
            }, 10000);
          }
        });
    } else {
      //direct to login
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.resetPassword h1 {
  color: #51a684;
}

.resetPassword {
  max-width: 800px;
}

.resetPassword .form {
  max-width: 75%;
}

.resetPassword .formcontainer .v-btn {
  margin-bottom: 6px;
  width: 100%;
  box-shadow: 3px 3px;
}

.resetPassword .forgot {
  color: gray;
}

div :deep(.v-messages__message) {
  line-height: 1.33333;
}

div :deep(.v-counter) {
  line-height: 1.33333;
}
</style>
